// extracted by css-extract-rspack-plugin
export default {"cls1":"ButtonsPage-cls1_JKu","cls2":"ButtonsPage-cls2_MRQ ButtonsPage-cls1_JKu","spacing-pack":"ButtonsPage-spacing-pack_ZJ1"};